'use strict';

import React from 'react';
import UserActions from 'actions/UserActions';
import UserStore from 'stores/UserStore';
import {Link} from 'react-router';
import API from 'sources/API';
import 'styles/Login.scss';

let logoImage = require('../images/icon.png');

class LoginComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      errMsg: UserStore.getState().errMsg
    };
    this.handleChange = this.handleChange.bind(this);
    this.onUserChange = this.onUserChange.bind(this);
    this.login = this.login.bind(this);
    this.clearErrMsg = this.clearErrMsg.bind(this);
  }
  clearErrMsg() {
    UserActions.updateErrMsg('');
  }
  handleChange(event) {
    let state = {};
    state[event.target.name] = event.target.value;
    this.setState(state);
  }
  componentDidMount() {
    this.clearErrMsg();
    UserStore.listen(this.onUserChange);
    // goole anlaytics 
    window.ga('set', 'page', this.props.location.pathname);
    window.ga('send', 'pageview');
  }
  componentWillUnmount() {
    UserStore.unlisten(this.onUserChange);
  }
  onUserChange(state) {
    this.setState(state);
  }
  login(event) {
    event.preventDefault();
    UserActions.login(this.state.email, this.state.password);
  }
  render() {
    let form, helper;
    if (this.state.errMsg) {
      helper = (
        <div className="row">
          <div className="large-9 medium-9 small-9 small-centered columns">
            <div className="error">
              <button className="close-button" aria-label="Close alert" onClick={this.clearErrMsg} type="button">
                <span aria-hidden="true">&times;</span>
              </button>
              {this.state.errMsg}
            </div>
          </div>
        </div>
      );
    }
    form = (
      <form className="row" onSubmit={this.login}>
        <div className="large-9 medium-9 small-9 small-centered columns">
          <div className="border-round">
            <div className="row border-bottom">
              <div className="small-3 columns pr-0">
                <label className="text-right middle">邮箱：</label>
              </div>
              <div className="small-9 columns pl-0">
                <input type="text" name="email" placeholder="" value={this.state.email} onChange={this.handleChange} />
              </div>
            </div>
            <div className="row">
              <div className="small-3 columns pr-0">
                <label className="text-right middle">密码：</label>
              </div>
              <div className="small-9 columns pl-0">
                <input type="password" name="password" placeholder="" value={this.state.password} onChange={this.handleChange} />
              </div>
            </div>
          </div>
          <button type="submit" className="login-btn button expanded button">登录</button>
          <Link to="/forget" className="float-left fz-12">忘记密码？</Link>
          <Link to='/regist' className="float-right fz-12">注册？</Link>
        </div>
      </form>
    );
    return (
      <div className="login-component">
        <div className="row logo large-6 medium-6 small-6 small-centered columns">
          <img src={logoImage} width="50" />
          <h1>小地球旅行</h1>
        </div>
        {form}
        {helper}
        <footer>2016 @北京小地球科技有限公司</footer>
      </div>
    );
  }
}

LoginComponent.displayName = 'LoginComponent';

export default LoginComponent;



// WEBPACK FOOTER //
// ./src/components/LoginComponent.js